(function () {
  const targets = document.querySelectorAll(".fade");
  const observer = "IntersectionObserver" in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          entry.target.classList.toggle("active", entry.isIntersecting);
        });
      }, { threshold: 0.18 })
    : null;

  targets.forEach((target) => {
    if (observer) {
      observer.observe(target);
    } else {
      target.classList.add("active");
    }
  });

  const badge = document.createElement("div");
  badge.className = "y2k-badge";
  badge.textContent = "NOW LOADING: KAYOKYOKU";
  document.body.appendChild(badge);

  const status = document.createElement("div");
  status.className = "y2k-status";
  status.textContent = "WELCOME TO OBENTO BOX";
  document.body.appendChild(status);

  const visitor = document.createElement("div");
  visitor.className = "y2k-visitor";
  visitor.textContent = "VISITOR 000" + Math.floor(100 + Math.random() * 899);
  document.body.appendChild(visitor);

  const phrases = [
    "JAPANESE VINYL ONLINE",
    "DIRECT FROM JAPAN",
    "NO DUPLICATES",
    "FIRST_OBENTO BONUS READY"
  ];
  let phraseIndex = 0;
  setInterval(() => {
    phraseIndex = (phraseIndex + 1) % phrases.length;
    status.textContent = phrases[phraseIndex];
  }, 1800);

  let lastSparkle = 0;
  window.addEventListener("pointermove", (event) => {
    const now = Date.now();
    if (now - lastSparkle < 70) return;
    lastSparkle = now;

    const sparkle = document.createElement("span");
    sparkle.className = "sparkle";
    sparkle.style.left = event.clientX + "px";
    sparkle.style.top = event.clientY + "px";
    document.body.appendChild(sparkle);
    setTimeout(() => sparkle.remove(), 760);
  }, { passive: true });

  document.querySelectorAll(".section_div > div, .manga, #couponsection, #scroll").forEach((panel, index) => {
    panel.style.setProperty("--y2k-index", index);
  });
})();
